import { render } from "./CompanyConfiguration.vue?vue&type=template&id=2b10a63a&scoped=true"
import script from "./CompanyConfiguration.vue?vue&type=script&lang=js"
export * from "./CompanyConfiguration.vue?vue&type=script&lang=js"

import "./CompanyConfiguration.vue?vue&type=style&index=0&id=2b10a63a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b10a63a"]])

export default __exports__